import { faMicrosoft } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { CustomFontAwesomeIconProps } from './types/custom-font-awesome-icon.props';

export const Microsoft = (props: CustomFontAwesomeIconProps) => {
  return (
    <FontAwesomeIcon
      icon={faMicrosoft}
      {...props}
    />
  );
};
